import { useEffect, useState } from 'react'

import { api } from '../api'
import type { AccessResponse } from '../../contracts/api'
import { Paywall } from '../components/Paywall'
import './access.css'

function until(date: string | null): string {
  if (!date) return ''
  const parsed = new Date(date)
  if (Number.isNaN(parsed.getTime())) return ''
  return parsed.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' })
}

/**
 * Что уже открыто и что можно открыть. Отдельным экраном, а не строкой в
 * подвале: покупка не должна попадаться на глаза посреди чтения портрета.
 */
export function Access() {
  const [state, setState] = useState<AccessResponse | null>(null)

  useEffect(() => {
    let cancelled = false
    api
      .get<AccessResponse>('/api/access')
      .then((result) => {
        if (!cancelled) setState(result)
      })
      .catch(() => undefined)
    return () => {
      cancelled = true
    }
  }, [])

  const subscribedUntil = until(state?.access.subscribedUntil ?? null)

  return (
    <div className="screen access">
      <div className="topbar">
        <div className="brand">АТЛАС</div>
        <div className="topnote">доступ</div>
      </div>
      <h1 className="display">Доступ</h1>

      {state && (
        <div className="card access-card">
          <div className="lbl">Сейчас открыто</div>
          <p>
            {state.access.fullAtlas
              ? 'Полный Атлас: все главы портрета, комнаты расчётов и экспорт.'
              : 'Бесплатная часть: печать, первое пересечение, карточка дня и открытые главы портрета.'}
          </p>
          <p>
            {state.access.subscribed
              ? `Подписка активна${subscribedUntil ? ` до ${subscribedUntil}` : ''}: «мы сегодня» и вопросы оракула.`
              : 'Подписки нет: «мы сегодня» и повторные вопросы оракула пока закрыты.'}
          </p>
        </div>
      )}

      <Paywall />
    </div>
  )
}
